import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import CustomModal from "../../packages/CustomModal";
import WPAgGrid from "../../packages/WPAgGrid/WPAgGrid";
import { CustomModalButtons } from "../../constants/global.constants";
import { CorrectIcon, WrongIcon } from "../../assets/icons";
import "./PlantChecklist.scss";

const PlantChecklist = ({ setShowPlantChecklist, checkListData }) => {
  const { t } = useTranslation();
  const gridRef = useRef("plant-checklist-grid");

  const handleClose = ({ target }) => {
    if (
      target.id === CustomModalButtons.CONFIRM ||
      target.id === CustomModalButtons.CLOSE
    ) {
      setShowPlantChecklist(false);
    }
  };

  const getIcon = (value) => (value ? <CorrectIcon /> : <WrongIcon />);

  const formattedRowData = checkListData?.map((row) => ({
    ...row,
    column_mapping: getIcon(row.column_mapping),
    reference_conditions: getIcon(row.reference_conditions),
    default_cip_information: getIcon(row.default_cip_information),
  }));

  const columnDefs = [
    {
      id: 1,
      headerName: t("ValueStrings.train"),
      field: "train",
      flex: 1,
      minWidth: 70,
    },
    {
      id: 2,
      headerName: t("plantChecklist.columnMapping"),
      field: "column_mapping",
      flex: 1,
      minWidth: 160,
      cellRenderer: (params) => params.value,
    },
    {
      id: 3,
      headerName: t("plantChecklist.referenceConditions"),
      field: "reference_conditions",
      flex: 1,
      minWidth: 160,
      cellRenderer: (params) => params.value,
    },
    {
      id: 4,
      headerName: t("plantChecklist.defaultCIPInfo"),
      field: "default_cip_information",
      flex: 1,
      minWidth: 160,
      cellRenderer: (params) => params.value,
    },
  ];

  return (
    <CustomModal
      header={t("plantChecklist.title")}
      headerHelper={t("plantChecklist.description")}
      confirmBtn={t("ValueStrings.okay")}
      onModalClose={handleClose}
      customclass="plant-checklist-modal"
      headerClass="plant-checklist-modal-header"
    >
      {formattedRowData.length > 0 && (
        <div className="ro-ag-table">
          <WPAgGrid
            gridRef={gridRef}
            columnDefs={columnDefs}
            rowData={formattedRowData}
            tableHeight={"200px"}
          />
        </div>
      )}
    </CustomModal>
  );
};

export default PlantChecklist;
